export const ADD_TOPPING = 'ADD_TOPPING';
export const REMOVE_TOPPING = 'REMOVE_TOPPING';
export const SET_TOPPINGS = 'SET_TOPPINGS';
export const FETCH_TOPPINGS_FAILED = 'FETCH_TOPPINGS_FAILED';

export const ADD_PIZZA_TO_CART = 'ADD_PIZZA_TO_CART';
export const REMOVE_PIZZA_FROM_CART = 'REMOVE_PIZZA_FROM_CART';
export const PURCHASING = 'PURCHASING';
export const CLEAR_CART = 'CLEAR_CART';
export const CANCEL_PURCHASING = 'CANCEL-PURCHASING';
export const CALCULATE_TOTAL_PRICE = 'CALCULATE_TOTAL_PRICE';

export const PURCHASE_INIT = 'PURCHASE_INIT';
export const PURCHASE_PIZZA_START = 'PURCHASE_PIZZA_START';
export const PURCHASE_PIZZA_SUCCESS = 'PURCHASE_PIZZA_SUCCESS';
export const PURCHASE_PIZZA_FAIL = 'PURCHASE_PIZZA_FAIL';

export const FETCH_ORDERS_START = 'FETCH_ORDERS_START';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAIL = 'FETCH_ORDERS_FAIL';

export const AUTH_START = 'AUTH_START';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';

export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';